<template>
  <v-container fluid grid-list-lg>
    <v-card>
      <v-app-bar flat>
        <v-icon>extension</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Configuración General del Sistema</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-app-bar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-card>
                <v-app-bar flat>
                  <v-icon>perm_identity</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Customización del Sistema</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>
                <v-card-text>
                  <v-container fluid>
                    <v-row no-gutters align="center">
                      <v-col>
                        <v-radio-group
                          v-model="model.ingresoPorDefectoPor"
                          label="Para identificar a las Pesonas utilizar"
                          row
                        >
                          <v-radio
                            label="Documento"
                            class="caption"
                            key="documento"
                            value="documento"
                          ></v-radio>
                          <v-radio
                            label="Cuil"
                            class="caption"
                            key="cuil"
                            value="cuil"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.validacionGeograficaTelefono"
                          label="Usar Base Numeración Geográfica"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      v-if="!model.validacionGeograficaTelefono"
                    >
                      <v-col>
                        <v-switch
                          v-model="model.telefonoSeparadoPorGuion"
                          label="Números de Teléfono Separados por Guión"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.permitirMultiplesDomiciliosPorCliente"
                          label="Permitir más de un Domicilio por Cliente"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.legajoVirtualHabilitado"
                          label="Habilitar Legajo Virtual"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.integracionLlamadosAnura"
                          label="Integración con Servicio llamadas Anura (https://api.anura.com.ar/)"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <!-- <v-row no-gutters>
                                        <v-col >
                                            <v-switch v-model="model.conexionSMS" label="Integración con Servicio de Envío SMS"></v-switch>                                            
                                        </v-col>
                                    </v-row> -->
                    <!-- <div v-if="model.conexionSMS"> -->

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.conexionConsultaSiisa"
                          label="Integración con Servicio de Consultas SiiSA (http://www.siisa.com.ar/)"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-container v-if="model.conexionConsultaSiisa">
                        <v-row>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.consultaSiisaUsuario"
                              label="Usuario"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.consultaSiisaPin"
                              label="PIN"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.consultaSiisaClave"
                              label="Clave"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>

                    <v-row no-gutters v-if="!model.motorDecisionPropio">
                      <v-col>
                        <v-switch
                          v-model="model.conexionMotorSiisa"
                          label="Integración con Motor de Decisión SiiSA (http://www.siisa.com.ar/)"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-container
                        v-if="
                          !model.motorDecisionPropio && model.conexionMotorSiisa
                        "
                      >
                        <v-row>
                          <v-col cols="3">
                            <v-text-field
                              v-model="model.motorSiisaUsuario"
                              label="Usuario"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field
                              v-model="model.motorSiisaPin"
                              label="PIN"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="model.motorSiisaClave"
                              label="Clave"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="model.motorSiisaPolitica"
                              label="Política Nº"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="model.motorSiisaPoliticaDirigido"
                              label="Política Dirigidos Nº"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="model.motorSiisaResultadosAprueba"
                              label="Resultados con los que se considera Aprobado"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                  </template>
                                  <template>
                                    <p>
                                      Ingrese los valores, en minúscula,
                                      separados por una coma
                                    </p>
                                  </template>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.guenoIntegracionHabilitada"
                          label="Integración con Güeno (wwww.gueno.com)"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <v-row no-gutters v-if="model.guenoIntegracionHabilitada">
                      <v-col cols="12">
                        <v-text-field
                          v-model="model.guenoUrlLink"
                          label="Url Link"
                        >
                          <template v-slot:append>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">info</v-icon>
                              </template>
                              <template>
                                <p>Ingrese la Url del link a generar</p>
                              </template>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!-- habilitación de links -->
                    <v-row no-gutters v-if="model.guenoIntegracionHabilitada">
                      <v-col>
                        <v-switch
                          v-model="linkGuenoComer"
                          label="Mostrar a Comer"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkGuenoOnline"
                          label="Mostrar a Online"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkGuenoComercio"
                          label="Mostrar a Comercio"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkGuenoConcentrador"
                          label="Mostrar a Concentrador"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkGuenoSucursal"
                          label="Mostrar a Sucursal"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <!-- integracion digiVentures -->
                    <v-col>
                      <v-switch
                        v-model="model.digiVenturesIntegracionHabilitada"
                        label="Integración con DigiVentures"
                      ></v-switch>
                    </v-col>

                    <v-row
                      no-gutters
                      v-if="model.digiVenturesIntegracionHabilitada"
                    >
                      <v-col cols="12">
                        <v-text-field
                          v-model="model.digiVenturesUrl"
                          label="Url Link"
                        >
                          <template v-slot:append>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">info</v-icon>
                              </template>
                              <template>
                                <p>Ingrese la Url</p>
                              </template>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          v-model="model.digiVenturesApplicationId"
                          label="Id"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          v-model="model.digiVenturesSecret"
                          label="Secret"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <!-- habilitación de links -->
                    <v-row
                      no-gutters
                      v-if="model.digiVenturesIntegracionHabilitada"
                    >
                      <v-col>
                        <v-switch
                          v-model="linkDigiventuresComer"
                          label="Mostrar a Comer"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkDigiventuresOnline"
                          label="Mostrar a Online"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkDigiventuresComercio"
                          label="Mostrar a Comercio"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkDigiventuresConcentrador"
                          label="Mostrar a Concentrador"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          v-model="linkDigiventuresSucursal"
                          label="Mostrar a Sucursal"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>

              <v-row> &nbsp; </v-row>
              <!-- integración SMS -->
              <v-card>
                <v-app-bar flat>
                  <v-icon>perm_identity</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Integración con Servicios de Envío de SMSs</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>
                <v-card-text>
                  <v-container fluid>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.conexionSmsMasivos"
                          label="Integración con Servicio SMS Masivos (https://www.smsmasivos.com.ar/)"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-container v-if="model.conexionSmsMasivos">
                        <v-row>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.smsMasivosUsuario"
                              label="Usuario"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.smsMasivosPin"
                              label="PIN"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.smsMasivosClave"
                              label="Clave"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.conexionSondeos"
                          label="Integración con Servicio SMS Sondeos (http://www.snd.com.ar/)"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-container v-if="model.conexionSondeos">
                        <v-row>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.sondeosUsuario"
                              label="Usuario"
                            ></v-text-field>
                          </v-col>
                          <!-- <v-col cols="4">
                                                    <v-text-field  v-model="model.sondeosPin" label="PIN" ></v-text-field>    
                                                </v-col> -->
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.sondeosClave"
                              label="Clave"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>

                    <v-row no-gutters>
                      <v-container v-if="model.conexionSondeos">
                        <v-row>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.sondeosCodLargo"
                              label="Código Mensaje Largo"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.sondeosCodCorto"
                              label="Código Mensaje Corto"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.conexionTeleprom"
                          label="Integración con Servicio SMS Teleprom"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-container v-if="model.conexionTeleprom">
                        <v-row>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.telepromUsuario"
                              label="Usuario"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field
                              v-model="model.telepromClave"
                              label="Clave"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-if="
                            model.conexionSmsMasivos ||
                            model.conexionSondeos ||
                            model.conexionTeleprom
                          "
                          v-model="model.verificacionTelefonicaPorSms"
                          label="Habiltiar envío de SMS para Verificación de Celulares"
                        ></v-switch>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-if="
                            model.conexionSmsMasivos ||
                            model.conexionSondeos ||
                            model.conexionTeleprom
                          "
                          v-model="model.smsRechazoDebito"
                          label="Enviar SMS Rechazo Débito"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-autocomplete
                          v-model="model.smsModelRechazoDebitoId"
                          :items="listModelosSMS"
                          autocomplete="disabled"
                          v-if="model.smsRechazoDebito"
                          item-text="descripcion"
                          item-value="id"
                          label="Modelo de SMS"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-if="
                            model.conexionSmsMasivos ||
                            model.conexionSondeos ||
                            model.conexionTeleprom
                          "
                          v-model="model.smsModoTest"
                          label="Activar Modo Testing"
                          hint="Al activar esta opción, podrá definir a qué números se enviarán todos los mensajes"
                          persistent-hint
                        ></v-switch>
                      </v-col>
                      <v-col cols="8" v-if="model.smsModoTest">
                        <v-text-field
                          v-model="model.smsEnviarANumeros"
                          label="Enviar SMS a los siguientes números"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <!-- </div> -->
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <!-- customización de reglas del negocio -->
              <v-card>
                <v-app-bar flat>
                  <v-icon>perm_identity</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Customización del Reglas del Negocio</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>
                <v-card-text>
                  <v-container fluid>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.motorDecisionPropio"
                          label="Utilizar Motor de Decisión Propio"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.auditoriaLegajoFisico"
                          label="Auditar Legajo Físico"
                        >
                          <template v-slot:append>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">info</v-icon>
                              </template>
                              <template>
                                <p>
                                  Al habilitar esta opción, se permite realizar
                                  un seguimiento, mediante cambios de estado,
                                  del Legajo Físico asociado a un Crédito
                                </p>
                              </template>
                            </v-tooltip>
                          </template>
                        </v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.auditoriaLegajoDigital"
                          label="Auditar Legajo Digital"
                        >
                          <template v-slot:append>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">info</v-icon>
                              </template>
                              <template>
                                <p>
                                  Al habilitar esta opción, se permite realizar
                                  un seguimiento, mediante cambios de estado,
                                  del Legajo Digital asociado a un Crédito
                                </p>
                              </template>
                            </v-tooltip>
                          </template>
                        </v-switch>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="8">
                        <v-switch
                          v-model="model.limitarCreditosEfectivo"
                          label="Limitar Créditos en Efectivo Simultáneos"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model="model.maximaCantidadEfectivo"
                          label="Cantidad Máxima"
                          v-if="model.limitarCreditosEfectivo"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.usarTopeCapitalParaClientes"
                          label="Utilizar Tope de Capital para Clientes"
                          hint="Al seleccionar esta opción, se podrá establecer un saldo por cliente, que aplicará como tope al momento del otorgamiento"
                          persistent-hint
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="8">
                        <v-switch
                          v-model="model.limitarVencimientoTarjeta"
                          label="Limitar Fecha Vencimiento de Tarjetas"
                          hint="Al seleccionar esta opción, no se permitirá cargar tarjetas de débito con vencimientos anteriores a la última cuota del crédito."
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model="
                            model.mesesEntreUltimaCuotaYVencimientoTarjeta
                          "
                          label="Meses entre Última Cuota y Vencimiento Tarjeta"
                          v-if="model.limitarVencimientoTarjeta"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="center">
                      <v-col cols="4" class="body-1">
                        <div>Tasa Punitorio Diario (%)</div>
                      </v-col>
                      <v-col cols="1">
                        <v-text-field
                          v-model="model.tasaPunitoriosDiaria"
                          suffix="%"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="center">
                      <v-col class="body-1" cols="8">
                        <div>Tasa Cálculo Punitorio Fijo (en Cta. Cte.)</div>
                      </v-col>
                      <v-col cols="1">
                        <v-text-field
                          v-model="model.porcentajeCalculoPunitoriosCtaCte"
                          suffix="%"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row no-gutters align="center">
                      <v-col class="body-1" cols="8">
                        <div>Saldo Máximo Cajas</div>
                      </v-col>
                      <v-col cols="1">
                        <v-text-field
                          v-model="model.maximoSaldoCaja"
                          hint="Dejar en cero para no utilizarlo"
                          suffix="$"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row no-gutters align="center">
                      <v-col cols="4" class="body-1">
                        <div>Política de Renovación</div>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>

                    <v-row dense align="center">
                      <v-col cols="4" class="body-2">
                        <div>Renovar con un Porcentaje pago del</div>
                      </v-col>
                      <v-col cols="1">
                        <v-text-field
                          v-model="model.renovacionCreditoPorcentajePago"
                          suffix="%"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" class="body-2">
                        <div>y un Vector de Atraso Máximo de</div>
                      </v-col>
                      <v-col cols="1">
                        <v-text-field
                          v-model="model.renovacionCreditoVectorAtrasoMaximo"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row dense align="center">
                      <v-col class="body-1">
                        <div>Archivo Políticas de Riesgo</div>
                      </v-col>
                    </v-row>
                    <v-row dense align="center">
                      <v-col cols="6">
                        <v-file-input
                          v-model="archivoPoliticas"
                          accept="application/pdf"
                          placeholder="Seleccione el archivos a subir"
                          label="Archivos Políticas"
                          chips
                          show-size
                          prepend-icon="mdi-paperclip"
                        >
                        </v-file-input>
                      </v-col>
                      <v-col cols="4">
                        <v-btn color="success" @click="uploadFilePoliticas">
                          Subir Archivo
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row dense align="center">
                      <v-col class="body-1">
                        <div>Archivo Notificaciones Generales</div>
                      </v-col>
                    </v-row>
                    <v-row dense align="center">
                      <v-col cols="6">
                        <v-file-input
                          v-model="archivoNotificaciones"
                          accept="application/pdf"
                          placeholder="Seleccione el archivos a subir"
                          label="Archivos Notificaciones Generales"
                          chips
                          show-size
                          prepend-icon="mdi-paperclip"
                        >
                        </v-file-input>
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          color="success"
                          @click="uploadFileNotificaciones"
                        >
                          Subir Archivo
                        </v-btn>
                      </v-col>
                    </v-row>
                    
                    <v-divider></v-divider>
                    <v-row dense align="center">
                      <v-col class="body-1">
                        <div>Imagen Banner Pantalla Login</div>
                      </v-col>
                    </v-row>
                    <v-row dense align="center">
                      <v-col cols="6">
                        <v-file-input
                          v-model="imagenBannerLogin"
                          placeholder="Seleccione la imagen a subir"
                          accept="image/png, image/jpeg, image/bmp"
                          label="Banner Pantalla Login"
                          chips
                          show-size
                          prepend-icon="mdi-paperclip"
                        >
                        </v-file-input>
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          color="success"
                          @click="uploadBannerImage(bannerImageOptions.LOGIN_BANNER)"
                        >
                          Subir Archivo
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row dense align="center">
                      <v-col class="body-1">
                        <div>Imagen Banner Pantalla Home</div>
                      </v-col>
                    </v-row>
                    <v-row dense align="center">
                      <v-col cols="6">
                        <v-file-input
                          v-model="imagenBannerHomePage"
                          placeholder="Seleccione la imagen a subir"
                          accept="image/png, image/jpeg, image/bmp"
                          label="Banner Pantalla Home"
                          chips
                          show-size
                          prepend-icon="mdi-paperclip"
                        >
                        </v-file-input>
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          color="success"
                          @click="uploadBannerImage(bannerImageOptions.HOME_PAGE_BANNER)"
                        >
                          Subir Archivo
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-container>
                </v-card-text>
              </v-card>
              <v-row> &nbsp; </v-row>
              <!-- customización de la caja -->
              <v-card>
                <v-app-bar flat>
                  <v-icon>perm_identity</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Customización del la Caja</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>
                <v-card-text>
                  <v-container fluid>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.cajaMostrarSaldoActual"
                          label="Mostrar Saldo Actual"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-switch
                          v-model="model.cajaMostrarMovimientosDelDia"
                          label="Mostrar Movimientos del Día"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="saveItem">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';
import BANNER_IMAGE_OPTIONS from '@/options/bannerImageOptions.js'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      archivoPoliticas: {},
      archivoNotificaciones: {},
      //integracionEnvioSMS:false,
      model: {}, // registro para ver/editar
      listModelosSMS: [],
      linkDigiventuresComer: false,
      linkDigiventuresOnline: false,
      linkDigiventuresComercio: false,
      linkDigiventuresConcentrador: false,
      linkDigiventuresSucursal: false,
      linkGuenoComer: false,
      linkGuenoOnline: false,
      linkGuenoComercio: false,
      linkGuenoConcentrador: false,
      linkGuenoSucursal: false,
      bannerImageOptions: BANNER_IMAGE_OPTIONS,
      imagenBannerLogin: {},
      imagenBannerHomePage: {}
    };
  },
  async created() {
    this.editItem();
    this.loadModelosSMS();
    //this.integracionEnvioSMS = this.model.conexionSMS;
  },
  computed: {
    ...mapGetters([
      'checkCanCreate',
      'checkCanUpdate',
      'checkCanDelete',
      'getActionFromLink',
      'error',
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setParametrosGenerales',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async editItem() {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      await this.getItem();

      this.editMode = true;
      this.suspend = false;
    },
    async getItem() {
      this.loading = true;
      try {
        var result = await http.get('parametrosgenerales');
        this.model = result;

        // de-codifico los la visibilidad de los links
        this.linkDigiventuresComer = this.model.linkDigiventuresVisiblePara & 1;
        this.linkDigiventuresOnline =
          this.model.linkDigiventuresVisiblePara & 2;
        this.linkDigiventuresComercio =
          this.model.linkDigiventuresVisiblePara & 4;
        this.linkDigiventuresConcentrador =
          this.model.linkDigiventuresVisiblePara & 8;
        this.linkDigiventuresSucursal =
          this.model.linkDigiventuresVisiblePara & 16;

        this.linkGuenoComer = this.model.linkGuenoVisiblePara & 1;
        this.linkGuenoOnline = this.model.linkGuenoVisiblePara & 2;
        this.linkGuenoComercio = this.model.linkGuenoVisiblePara & 4;
        this.linkGuenoConcentrador = this.model.linkGuenoVisiblePara & 8;
        this.linkGuenoSucursal = this.model.linkGuenoVisiblePara & 16;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async saveItem() {
      const isUpdate = !!this.model.id;
      await this.$validator.validateAll();

      if (this.errors.items.length > 0) return;

      if (this.model.conexionSondeos && this.model.conexionSMSMasivos) {
        this.alertWarning(
          'No puede configurar la conexión con más de una plataforma de envío de SMS.'
        );
        return;
      }

      // codifico los la visibilidad de los links
      this.model.linkDigiventuresVisiblePara = 0;
      if (this.linkDigiventuresComer)
        this.model.linkDigiventuresVisiblePara =
          this.model.linkDigiventuresVisiblePara + 1;
      if (this.linkDigiventuresOnline)
        this.model.linkDigiventuresVisiblePara =
          this.model.linkDigiventuresVisiblePara + 2;
      if (this.linkDigiventuresComercio)
        this.model.linkDigiventuresVisiblePara =
          this.model.linkDigiventuresVisiblePara + 4;
      if (this.linkDigiventuresConcentrador)
        this.model.linkDigiventuresVisiblePara =
          this.model.linkDigiventuresVisiblePara + 8;
      if (this.linkDigiventuresSucursal)
        this.model.linkDigiventuresVisiblePara =
          this.model.linkDigiventuresVisiblePara + 16;

      this.model.linkGuenoVisiblePara = 0;
      if (this.linkGuenoComer)
        this.model.linkGuenoVisiblePara = this.model.linkGuenoVisiblePara + 1;
      if (this.linkGuenoOnline)
        this.model.linkGuenoVisiblePara = this.model.linkGuenoVisiblePara + 2;
      if (this.linkGuenoComercio)
        this.model.linkGuenoVisiblePara = this.model.linkGuenoVisiblePara + 4;
      if (this.linkGuenoConcentrador)
        this.model.linkGuenoVisiblePara = this.model.linkGuenoVisiblePara + 8;
      if (this.linkGuenoSucursal)
        this.model.linkGuenoVisiblePara = this.model.linkGuenoVisiblePara + 16;

      if (isUpdate) {
        try {
          await http.put(
            'parametrosgenerales',
            JSON.stringify({ parametro: this.model })
          );

          // actualizo los parámetros en el store
          this.setParametrosGenerales(this.model);

          this.alertSuccess('Los cambios han sido guardados.');
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    async uploadFilePoliticas() {
      Vue.$log.debug(this.archivoPoliticas.name);
      if (this.archivoPoliticas.name == null) {
        this.alertWarning('Debe seleccionar un archivo.');
        return;
      }

      if (this.archivoPoliticas.type !== 'application/pdf') {
        this.alertWarning('El archivo debe ser de tipo PDF.');
        return;
      }

      this.loading = true;
      const formData = new FormData();
      Vue.$log.debug(this.archivoPoliticas);
      formData.append('file', this.archivoPoliticas);

      try {
        await http.post(
          '/parametrosGenerales/uploadfilepoliticasriesgo',
          formData
        );

        this.alertSuccess('El archivo fue actualizado.');
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async uploadFileNotificaciones() {
      Vue.$log.debug(this.archivoNotificaciones.name);
      if (this.archivoNotificaciones.name == null) {
        this.alertWarning('Debe seleccionar un archivo.');
        return;
      }

      if (this.archivoNotificaciones.type !== 'application/pdf') {
        this.alertWarning('El archivo debe ser de tipo PDF.');
        return;
      }

      this.loading = true;
      const formData = new FormData();
      Vue.$log.debug(this.archivoNotificaciones);
      formData.append('file', this.archivoNotificaciones);

      try {
        await http.post(
          '/parametrosGenerales/uploadfilenotificacionesgenerales',
          formData
        );

        this.alertSuccess('El archivo fue actualizado.');
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async uploadBannerImage(imageName) {
      const imageToUpload = imageName === this.bannerImageOptions.LOGIN_BANNER ? this.imagenBannerLogin : this.imagenBannerHomePage;
      
      if (imageToUpload.name == null) {
        this.alertWarning('Debe seleccionar una imagen.');
        return;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append('imageName', imageName);
      formData.append('file', imageToUpload);

      try {
        await http.post(
          '/parametrosGenerales/upload-banner-image',
          formData
        );

        this.alertSuccess('El banner fue actualizado.');
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadModelosSMS() {
      this.loading = true;
      try {
        var result = await http.get('modelossms');

        this.listModelosSMS = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
  },
};
</script>
